import { Box } from '@modusign/design-system';
import { useHistory } from 'react-router';

import ExcelUploadPageContent from './ExcelUploadPageContent';
import ExcelUploadPageHeader from './ExcelUploadPageHeader';

export default function SettingsAddressBookExcelUploadPage() {
  const history = useHistory();
  return (
    <Box textAlign="center">
      <ExcelUploadPageHeader
        onExit={() => {
          history.push('/settings/address-book');
        }}
      />
      <ExcelUploadPageContent />
    </Box>
  );
}
